export default {
    title: 'Calendario Settimanale',
    subtitle: 'Visualizza gli arrivi dei container programmati per settimana',
    currentWeek: 'Settimana Corrente',
    week: 'Settimana',
    weekNumber: 'Settimana {{number}}',
    noContainers: 'Nessun container programmato per questa settimana',
    containers: 'Container',
    origins: 'Origini',
    senders: 'Mittenti',
    totalValue: 'Valore Totale',
    commodities: 'Merci',
    expandDetails: 'Visualizza Dettagli',
    collapseDetails: 'Nascondi Dettagli',
    containerCount: '{{count}} container',
    containerCount_plural: '{{count}} container',
    originCount: '{{count}} origine',
    originCount_plural: '{{count}} origini',
    senderCount: '{{count}} mittente',
    senderCount_plural: '{{count}} mittenti',
    weekRange: '{{startDate}} - {{endDate}}',
    loading: 'Caricamento calendario...',
    error: 'Errore nel caricamento dei dati del calendario',
    retry: 'Riprova',
    // Target e obiettivi
    targetReached: 'Obiettivo Raggiunto',
    targetPending: 'Obiettivo in Corso',
    containerTarget: 'Target Container',
    revenueTarget: 'Target Fatturato',
    editTarget: 'Modifica Target',
    confirmed: 'confermati',
    pending: 'da confermare',
    // Trend Cards
    trendCards: {
        yearlyContainers: 'Container Annuali',
        yearlyRevenue: 'Fatturato Annuale',
        monthlyContainers: 'Container Mensili',
        monthlyRevenue: 'Fatturato Mensile',
    },
    // Chart
    chart: {
        titleContainers: 'Distribuzione Container per Settimana',
        titleRevenue: 'Distribuzione Fatturato per Settimana',
        yAxisContainers: 'Numero Container',
        yAxisRevenue: 'Fatturato (USD)',
        target: 'Target',
        confirmed: 'Confermati',
        pending: 'Da Confermare',
        total: 'Totale',
    },
    // View toggle
    viewContainers: 'Visualizza Container',
    viewRevenue: 'Visualizza Fatturato',
    // Target Modal
    targetModal: {
        title: 'Modifica Target Settimana {{week}}',
        containerTarget: 'Target Container',
        revenueTarget: 'Target Fatturato (USD)',
        useDefault: 'Usa target generico settimanale',
        resetToDefault: 'Ripristina al Target Generico',
    },
    // Footer
    viewingWeeks: 'Visualizzando {{count}} settimane per l\'anno {{year}}',
    noContainersForYear: 'Nessun container per {{year}}',
    noContainersMessage: 'Non ci sono container programmati per quest\'anno.',
    // View Mode
    viewMode: {
        carousel: 'Carousel',
        list: 'Lista',
    },
    // Carousel
    carousel: {
        previous: 'Precedente',
        next: 'Successiva',
        weekOf: 'Settimana {{current}} di {{total}}',
        jumpToCurrent: 'Vai alla Corrente',
        noWeekData: 'Nessun dato disponibile',
    },
    // List View
    listView: {
        week: 'Settimana',
        containerTarget: 'Target Container',
        revenueTarget: 'Target Fatturato',
        containers: 'Container',
        value: 'Valore',
        actions: 'Azioni',
        expand: 'Espandi',
        collapse: 'Comprimi',
        containersDetails: 'Dettagli Container ({{count}})',
        containerNumber: 'Numero Container',
        route: 'Rotta',
        eta: 'ETA',
        status: 'Stato',
        confirmation: 'Conferma',
    },
};
